import React, { useCallback, useState, Component } from 'react';
import { PlusIcon, SparklesIcon, ChevronLeftIcon, ChevronRightIcon, Loader2Icon, UploadIcon, XIcon, ImageIcon } from 'lucide-react';
type PictureSelectorProps = {
  onSelect: (image: string) => void;
  onStyleSelect: (style: string) => void;
};
const THEMED_IMAGES = [{
  name: 'Adventure',
  images: [{
    url: 'https://images.unsplash.com/photo-1594787318286-3d835c1d207f',
    alt: 'Toy truck',
    label: 'Truck'
  }, {
    url: 'https://images.unsplash.com/photo-1594787318286-3d835c1d207f',
    alt: 'Adventure vehicle',
    label: 'Explorer'
  }, {
    url: 'https://images.unsplash.com/photo-1594787318286-3d835c1d207f',
    alt: 'Adventure mobile',
    label: 'Journey'
  }]
}, {
  name: 'Animal Pals',
  images: [{
    url: 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308',
    alt: 'Cute bunny',
    label: 'Bunny'
  }, {
    url: 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308',
    alt: 'Friendly animal',
    label: 'Friend'
  }, {
    url: 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308',
    alt: 'Animal companion',
    label: 'Companion'
  }]
}, {
  name: 'Magic',
  images: [{
    url: 'https://images.unsplash.com/photo-1519138130-85a949fdcb4f',
    alt: 'Princess castle',
    label: 'Castle'
  }, {
    url: 'https://images.unsplash.com/photo-1519138130-85a949fdcb4f',
    alt: 'Magical place',
    label: 'Wonder'
  }, {
    url: 'https://images.unsplash.com/photo-1519138130-85a949fdcb4f',
    alt: 'Enchanted palace',
    label: 'Magic'
  }]
}];
export const PictureSelector = ({
  onSelect,
  onStyleSelect
}: PictureSelectorProps) => {
  const [selectedStyle, setSelectedStyle] = useState('A');
  const [customImage, setCustomImage] = useState<string | null>(null);
  const [prompt, setPrompt] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const illustrationStyles = [{
    id: 'A',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hJgG7WaMQVqX1ZZF28nUbs/ChatGPT_Image_May_23%2C_2025_at_05_12_41_PM.png',
    label: 'Crayon'
  }, {
    id: 'B',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mXtDC6Y4ajExAmGBGPoCpG/ChatGPT_Image_May_18%2C_2025_at_06_20_27_PM.png',
    label: 'Fuzzy'
  }, {
    id: 'D',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/up1qA9wkD8XpeMBGm7WTHa/ChatGPT_Image_May_18%2C_2025_at_06_47_32_PM.png',
    label: 'Bright'
  }, {
    id: 'E',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jh4rNecFsf88yj3W2xmMxm/ChatGPT_Image_May_30%2C_2025_at_02_01_51_PM.png',
    label: 'Pretty'
  }];
  return <div className="w-full space-y-6" data-id="element-758">
      
    </div>;
};